export default __webpack_public_path__ + "static/media/bg0_m.b22573cd.png";